import { ConfirmationDialog } from 'legacy/lut/components/shared/Confirm/ConfirmationDialog'
import { FC } from 'react'

import { TRANSLATION_KEYS } from '../../translations'

import { DELETE_INITIATIVE_CONFIRM_IDENTIFIER } from './configs'

export const DeleteInitiativeConfirm: FC = () => {
  return (
    <ConfirmationDialog
      translation
      identifier={DELETE_INITIATIVE_CONFIRM_IDENTIFIER}
      text={TRANSLATION_KEYS.deleteInitiativeDialog.dialogText}
      submitText={TRANSLATION_KEYS.deleteInitiativeDialog.submitButton}
    />
  )
}
